import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { requestJson, requestWithHeaders } from './WebUtils';
var GRAPH_API_URL = 'https://graph.microsoft.com/v1.0';
export var GRAPH_API_REQUEST = {
  scopes: ['User.Read', 'User.Read.All']
};
var USER_INFO_FIELDS = ['id', 'displayName', 'jobTitle', 'employeeId', 'userPrincipalName'];
export var getMyInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msalInstance) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return requestJson({
              msalInstance: msalInstance,
              scopes: GRAPH_API_REQUEST.scopes,
              url: "".concat(GRAPH_API_URL, "/me?$select=").concat(USER_INFO_FIELDS.join(','))
            }, 'GET', null);

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getMyInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getUserInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(msalInstance, username) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return requestJson({
              msalInstance: msalInstance,
              scopes: GRAPH_API_REQUEST.scopes,
              url: "".concat(GRAPH_API_URL, "/users/").concat(username, "?$select=").concat(USER_INFO_FIELDS.join(','))
            }, 'GET', null);

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getUserInfo(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getMyGroups = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(msalInstance) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", getGroupsInternal(msalInstance, "".concat(GRAPH_API_URL, "/me/memberOf")));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getMyGroups(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var getGroupsInternal = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(msalInstance, url) {
    var groups, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            groups = [];
            _context4.next = 3;
            return requestJson({
              msalInstance: msalInstance,
              scopes: GRAPH_API_REQUEST.scopes,
              url: url
            }, 'GET', null);

          case 3:
            response = _context4.sent;
            groups.push(response.value.map(function (value) {
              return value.displayName;
            }));

            if (!('@odata.nextLink' in response)) {
              _context4.next = 14;
              break;
            }

            _context4.t0 = groups.push;
            _context4.t1 = groups;
            _context4.t2 = _toConsumableArray;
            _context4.next = 11;
            return getGroupsInternal(msalInstance, response['@odata.nextLink']);

          case 11:
            _context4.t3 = _context4.sent;
            _context4.t4 = (0, _context4.t2)(_context4.t3);

            _context4.t0.apply.call(_context4.t0, _context4.t1, _context4.t4);

          case 14:
            return _context4.abrupt("return", groups);

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getGroupsInternal(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

export var getPortraitResponse = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(msalInstance, username) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", requestWithHeaders({
              msalInstance: msalInstance,
              scopes: GRAPH_API_REQUEST.scopes,
              url: "".concat(GRAPH_API_URL, "/users/").concat(username, "/photo/$value")
            }, 'GET', null, null));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getPortraitResponse(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();